import $ from 'jquery';
import Tips from './Tips';
/* ===============================================================
Form contacts class
=============================================================== */
class Forms {
    // Initialize
    constructor() {
        this.buttonSubmit = $('.irantheme-contact-form-submit');
        this.tip = new Tips();
        this.events();
    }

    // Events
    events() {
        this.buttonSubmit.on('click', (e) => {
            e.preventDefault();
            // Get current form sending
            let currentForm = $(e.target).parents('.irantheme-contact-form');
            // Name value form
            let nameValue = $(currentForm)
                .find('.irantheme-contact-form-name')
                .val();
            // Email value form
            let emailValue = $(currentForm)
                .find('.irantheme-contact-form-email')
                .val();
            // Website value form
            let websiteValue = $(currentForm)
                .find('.irantheme-contact-form-website')
                .val();
            // Subject value form
            let subjectValue = $(currentForm)
                .find('.irantheme-contact-form-subject')
                .val();
            // Desc value form
            let descValue = $(currentForm)
                .find('.irantheme-contact-form-desc')
                .val();
            if (emailValue != '' && subjectValue != '' && descValue != '') {
                // Send data form
                this.sendMessage(
                    nameValue,
                    emailValue,
                    websiteValue,
                    subjectValue,
                    descValue
                );
            } else {
                this.tip.createTip(
                    'error',
                    'پیام ارسال نشد! لطفا تمامی فیلد ها (ورودی) های الزامی را وارد کنید.'
                );
            }
        });
    }

    // Create like
    sendMessage(
        dataName,
        dataEmail,
        dataWebsite,
        dataSubject,
        dataDescription
    ) {
        let url = iranthemeWpData.restUrl + 'irantheme/v1/contact';
        $.ajax({
            beforeSend: (xhr) => {
                xhr.setRequestHeader('X-WP-Nonce', iranthemeWpData.nonce);
            },
            url: url,
            type: 'POST',
            data: {
                name: dataName,
                email: dataEmail,
                website: dataWebsite,
                subject: dataSubject,
                desc: dataDescription,
            },
            success: (response) => {
                this.tip.createTip('success', 'پیام شما با موفقیت ارسال شد.');
            },
            error: (response) => {
                console.log(response.responseText);

                if (response.responseText == 'limitStatus') {
                    this.tip.createTip(
                        'warning',
                        'پیام شما ارسال نشد !‌ شما هر ۱ ساعت یکبار قادر به ارسال پیام می باشید.'
                    );
                }
            },
        });
    }
}

export default Forms;
